import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Router } from '@angular/router';
import filters from 'assets/json/filtersItems.json'
import nftItemsLocale from 'assets/json/nftItems.json'
import { UserService } from 'app/services/user/user.service';
import { Web3Service } from 'app/services/web3/web3.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-assets',
  templateUrl: './assets.component.html',
  styleUrls: ['./assets.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AssetsComponent implements OnInit {
  public filters
  public parsedItems: any = []
  // public account
  public filterSearch
  public craftingLevels: any = [{ level: 1 }, { level: 2 }, { level: 3 }, { level: 4 }, { level: 5 }]
  public detailsParsed
  public openFilter
  wallet: string

  constructor(
    public http: HttpClient,
    public router: Router,
    public userService: UserService,
    public web3Service: Web3Service
  ) {

    this.wallet = this.userService._userInfoData.recordedWallet;
    this.filters = filters;
    this.openFilter = false;

    if (this.wallet) this.populatePage();

    // if (this.appComponent.accounts == undefined) {
    //   this.appComponent.accountsObservable.subscribe(async (item: any) => {
    //     this.wallet = item[0];
    //     if (this.wallet !== undefined && this.wallet !== "") {
    //       //this.getKmonBalance();
    //       //this.getHatchingTime();
    //       //this.setAllowance()
    //       //this.getKryptomons()
    //       //this.setAllowance();
    //       //setInterval(()=>{
    //       //this.getKryptomonsCheck();
    //       //}, 60000)      
    //       console.log(this.wallet)
    //       this.populatePage()
    //     }
    //   });
    // } else {
    //   this.wallet = this.appComponent.accounts[0];
    //   //this.getKmonBalance();
    //   //this.getHatchingTime();
    //   //this.setAllowance()
    //   //this.getKryptomons()
    //   //setInterval(()=>{
    //   //this.getKryptomonsCheck();
    //   //}, 60000)
    //   //this.setAllowance();
    //   this.populatePage()

    //   console.log(this.wallet)
    // }
  }

  ngOnInit(): void {
  }

  populatePage() {
    this.detailsParsed = false;
    this.parsedItems = []
    this.http.get(environment.apiBaseUrlV22 + "user/" + this.wallet + "/items?limit=1000").subscribe(async (responseItems: any) => {
      console.log(responseItems)
      this.http.get(environment.apiBaseUrlV22 + "user/" + this.wallet + "/nft-items?limit=1000").subscribe(async (responseNFT: any) => {
        console.log(responseNFT)
        let allItems = responseNFT.concat(responseItems)
        console.log(allItems)
        for (let i = 0; i < allItems.length; i++) {
          if (allItems[i].balance > 0 || allItems[i].count > 0) {

            let newObject: any = {}
            if (allItems[i].itemId) {
              newObject.kind = "nft";
              newObject.itemId = allItems[i].itemId;
              newObject.metadata = allItems[i].metadata;
              newObject.balance = allItems[i].balance
              newObject.metadata.nameFormatted = nftItemsLocale[allItems[i].metadata.name + '-name']
              newObject.metadata.descriptionFormatted = nftItemsLocale[allItems[i].metadata.name + '-description']

              if (allItems[i].metadata.properties.scope == "equip") {
                newObject.metadata.typeFormatted = "equipment"
                if (allItems[i].metadata.name.indexOf("guardian") > -1) {
                  newObject.metadata.descriptionFormatted = nftItemsLocale["guardian-description"]
                } else if (allItems[i].metadata.name.indexOf("conqueror") > -1) {
                  newObject.metadata.descriptionFormatted = nftItemsLocale["conqueror-description"]
                } else if (allItems[i].metadata.name.indexOf("vanquisher") > -1) {
                  newObject.metadata.descriptionFormatted = nftItemsLocale["vanquisher-description"]
                }

                if (allItems[i].metadata.name.indexOf("back") > -1) {
                  newObject.metadata.filter_category = "armour-back"
                } else if (allItems[i].metadata.name.indexOf("helm") > -1) {
                  newObject.metadata.filter_category = "armour-head"
                } else if (allItems[i].metadata.name.indexOf("chest") > -1) {
                  newObject.metadata.filter_category = "armour-chest"
                } else if (allItems[i].metadata.name.indexOf("leggings") > -1) {
                  newObject.metadata.filter_category = "armour-leg"
                }

                if (allItems[i].metadata.properties.type.indexOf("trainer") > -1 && allItems[i].metadata.name.indexOf("hoodie") > -1) {
                  newObject.metadata.filter_category = "clothing-chest"
                }

              } else if (allItems[i].metadata.properties.category == "caring-boost" && allItems[i].metadata.properties.type !== "material") {
                newObject.metadata.typeFormatted = "caring boost"
                newObject.metadata.filter_category = "powerups-items"
                allItems[i].metadata.name = "powerup-" + allItems[i].metadata.name
              } else if (allItems[i].metadata.properties.category == "treasure-hunt") {
                newObject.metadata.typeFormatted = "hunting boost"
                newObject.metadata.filter_category = "miscellaneous-hunter-pass"
              } else if (allItems[i].metadata.properties.type === "material") {
                newObject.metadata.typeFormatted = "crafting material"
                if (newObject.metadata.name == "toy-boost-token") {
                  newObject.chainId = "2722258935367507707706996859454145691648"
                  newObject.metadata.filter_category = "powerups-material"
                } else if (newObject.metadata.name == "food-boost-token") {
                  newObject.chainId = "2041694201525630780780247644590609268736"
                  newObject.metadata.filter_category = "powerups-material"
                } else if (newObject.metadata.name == "health-boost-token") {
                  newObject.chainId = "2381976568446569244243622252022377480192"
                  newObject.metadata.filter_category = "powerups-material"
                } else if (newObject.metadata.name == "training-boost-token") {
                  newObject.chainId = "3062541302288446171170371466885913903104"
                  newObject.metadata.filter_category = "powerups-material"
                } else if (newObject.metadata.name == "basic-armor-scraps") {
                  newObject.chainId = "10208471007628153903901238222953046343680"
                  newObject.metadata.filter_category = "armour-material"
                }
              } else if (allItems[i].metadata.properties.category === "badge") {
                newObject.metadata.typeFormatted = "badge"
                newObject.metadata.filter_category = "miscellaneous-badge"
              }

              /*if(allItems[i].metadata.properties.category=="caring-boost" && allItems[i].metadata.properties.type!=="material"){
                allItems[i].metadata.name = "powerup-"+allItems[i].metadata.name
              }*/

              if (/\d/.test(allItems[i].metadata.name)) {
                newObject.craftingStage = allItems[i].metadata.name.match(/\d+/)[0] // "3"
                newObject.craftingMax = 5;
                newObject.craftingPercentage = Math.round(newObject.craftingStage / newObject.craftingMax * 100)
              }

            } else {
              newObject.kind = "consumable";
              newObject.balance = allItems[i].count
              newObject.itemId = allItems[i].type;
              newObject.metadata = {}
              newObject.metadata.name = allItems[i].type;
              newObject.metadata.descriptionFormatted = nftItemsLocale[allItems[i].type]
              newObject.metadata.properties = {}
              newObject.metadata.properties.category = "consumable"

              if (newObject.itemId == "BATTLE_STAMINA_POTION") {
                newObject.metadata.nameFormatted = "battle stamina potion"
                newObject.metadata.image = "./assets/img/Icon/battle_stamina_potion.png"
                newObject.metadata.typeFormatted = "replay potion"
                newObject.chainId = "0x424154544c455f5354414d494e415f504f54494f4e0000000000000000000000"
                newObject.metadata.filter_category = "consumable-potion"
              } else if (newObject.itemId == "DIAMOND_STORY_CHEST") {
                newObject.metadata.nameFormatted = "diamond story chest"
                newObject.metadata.image = "./assets/img/Icon/lootbox-diamond.png"
                newObject.metadata.typeFormatted = "consumable box"
                newObject.chainId = "0x4449414d4f4e445f53544f52595f434845535400000000000000000000000000"
                newObject.metadata.filter_category = "consumable-lootbox"
                newObject.metadata.name = "DIAMOND_STORY_LOOTBOX";
              } else if (newObject.itemId == "LOOTBOX_BASIC") {
                newObject.metadata.nameFormatted = "lootbox bronze"
                newObject.metadata.image = "./assets/img/Icon/lootbox-bronze.png"
                newObject.metadata.typeFormatted = "consumable box"
                newObject.chainId = "0x4c4f4f54424f585f424153494300000000000000000000000000000000000000"
                newObject.metadata.filter_category = "consumable-lootbox"
              } else if (newObject.itemId == "LOOTBOX_MEDIUM") {
                newObject.metadata.nameFormatted = "lootbox silver"
                newObject.metadata.image = "./assets/img/Icon/lootbox-silver.png"
                newObject.metadata.typeFormatted = "consumable box"
                newObject.chainId = "0x4c4f4f54424f585f4d454449554d000000000000000000000000000000000000"
                newObject.metadata.filter_category = "consumable-lootbox"
              } else if (newObject.itemId == "LOOTBOX_PREMIUM") {
                newObject.metadata.nameFormatted = "lootbox gold"
                newObject.metadata.image = "./assets/img/Icon/lootbox-gold.png"
                newObject.metadata.typeFormatted = "consumable box"
                newObject.chainId = "0x4c4f4f54424f585f5052454d49554d0000000000000000000000000000000000"
                newObject.metadata.filter_category = "consumable-lootbox"
              } else if (newObject.itemId == "UNFREEZE_POTION") {
                newObject.metadata.nameFormatted = "unfreeze potion"
                newObject.metadata.image = "./assets/img/Icon/unfreeze-potion.png"
                newObject.metadata.typeFormatted = "consumable item"
                newObject.chainId = "0x554e465245455a455f504f54494f4e0000000000000000000000000000000000"
                newObject.metadata.filter_category = "consumable-potion"
              }
            }
            this.parsedItems.push(newObject)
          }

        }

        this.checkOpenOrder();
      })
    })
  }

  checkOpenOrder() {
    this.http.get(environment.apiBaseUrlV22 + "orders/1155/open?owner=" + this.wallet).subscribe(async (item: any) => {
      console.log(item)
      if (item.orders.length > 0) {
        for (let i = 0; i < item.orders.length; i++) {
          for (let x = 0; x < this.parsedItems.length; x++) {
            if (this.parsedItems[x].itemId == item.orders[i].assetId) {
              this.parsedItems[x].order = item.orders[i];
              this.parsedItems[x].order.priceFormatted = this.web3Service.fromWeiFloat(item.orders[i].priceInWei)
            }
          }
        }
      }
      this.detailsParsed = true;
      console.log(this.parsedItems)
    })
  }


  selectFilter(first, second) {
    this.filterSearch = this.filters[first].filterItems[second].filter;
    for (let x = 0; x < this.filters.length; x++) {
      if (x == first) {
        for (let i = 0; i < this.filters[x].filterItems.length; i++) {
          if (i == second) {
            this.filters[x].filterItems[i].selected = true;
          } else {
            this.filters[x].filterItems[i].selected = false;
          }
        }
      } else {
        for (let i = 0; i < this.filters[x].filterItems.length; i++) {
          this.filters[x].filterItems[i].selected = false;
        }
      }
    }
  }

  removeFilter() {
    this.filterSearch = ""
    for (let x = 0; x < this.filters.length; x++) {
      for (let i = 0; i < this.filters[x].filterItems.length; i++) {
        this.filters[x].filterItems[i].selected = false;
      }
    }
  }
  openDetails(item) {
    console.log(item)
    if (item.kind == 'consumable') {
      let id = item.chainId
      this.router.navigate(['/shop', id])
    } else if (item.metadata.properties.type == 'material') {
      let id = item.chainId
      let baseUrl = "_items"
      if (item.metadata.name.indexOf('scraps') >= 0) {
        var addon = "0"
      } else {
        var addon = "1"
      }
      this.router.navigate(['/shop', baseUrl, id, addon])
    } else {
      let id = item.itemId
      this.router.navigate(['/assets/details', id])
    }
  }
}
